"use client";

import * as React from "react";
import TwoColumnLayout from "@/components/institution/TwoColumnLayout";
import issuesAndReportsImage from "@/assets/img/productive.png";
import { translations } from "@/messages";
import { useLocale } from "use-intl";
import { LinkItem } from "@/components/institution/LinkButtonArray";
import { api } from "@/lib/trpc/client";
const IssuesAndReportsSection: React.FC<{
  baseUrl: string;
  issuesAndReportsLinks: LinkItem[];
}> = ({
  baseUrl,
  issuesAndReportsLinks
}) => {
  const locale = useLocale() as keyof typeof translations;
  return <TwoColumnLayout title={translations[locale]["institution"]["problemEncounterTitle"]} description={translations[locale]["institution"]["helpOfferDescription"]} links={issuesAndReportsLinks} imageSrc={issuesAndReportsImage} baseUrl={baseUrl} data-sentry-element="TwoColumnLayout" data-sentry-component="IssuesAndReportsSection" data-sentry-source-file="IssuesAndReportsSection.tsx" />;
};
export default IssuesAndReportsSection;